<template>
  <div>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="alert.message = ''"
      ></button>
      <i :class="alert.icon"></i> &nbsp;
      <strong>{{ alert.message }}</strong>
      <br />
      {{ alert.reason }}
    </div>
    <label>
      Motivo da alteração
      <span class="m--font-danger">*</span>
    </label>
    <input
      type="text"
      ref="change_reason"
      class="form-control"
      maxlength="255"
      v-model="change_reason"
      placeholder="Motivo da alteração"
    />
    <hr />
    <div
      class="m-accordion m-accordion--default"
      id="m_accordion"
      role="tablist"
    >
      <div
        class="m-accordion__item"
        v-for="detail in data"
        :key="detail.type_id"
      >
        <div
          class="m-accordion__item-head collapsed"
          role="tab"
          :id="`m_accordion_${detail.key}_head`"
          data-toggle="collapse"
          :href="`#m_accordion_${detail.key}_body`"
          aria-expanded="false"
        >
          <span class="m-accordion__item-icon">
            <i :class="detail.icon"></i>
          </span>
          <span class="m-accordion__item-title">
            {{ detail.title }}
            <i
              class="fas fa-info-circle info-icon"
              v-b-tooltip
              :title="detail.tooltip"
            ></i>
            <i
              v-show="
                detail.datas.amount > 0 &&
                detail.datas.surplus_price &&
                detail.key != 'enterpriseSession'
              "
              class="far fa-check m--font-success ml-2"
            ></i>
            <i
              v-show="checkSucessEnterpriseSession(detail)"
              class="far fa-check m--font-success ml-2"
            ></i>
          </span>
          <span class="m-accordion__item-mode"></span>
        </div>
        <div
          class="m-accordion__item-body collapse"
          :id="`m_accordion_${detail.key}_body`"
          role="tabpanel"
          :aria-labelledby="`m_accordion_${detail.key}_head`"
          data-parent="#m_accordion"
          style
        >
          <div
            class="m-accordion__item-content"
            v-if="detail.key != 'enterpriseSession'"
          >
            <div>
              <div class="row">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Quantidade</span>
                    </div>
                    <input
                      type="number"
                      step="1"
                      min="0"
                      max="999999999"
                      class="form-control"
                      v-model="detail.datas.amount"
                      placeholder="0"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Valor excedente</span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.surplus_price"
                    ></money>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <div
            class="m-accordion__item-content"
            v-if="detail.key == 'enterpriseSession'"
          >
            <div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-check form-check-inline">
                    <input
                      id="use_facebook_bonus"
                      class="form-check-input"
                      type="checkbox"
                      v-model="detail.datas.useBonusFacebook"
                      value="0"
                    />
                    <label class="form-check-label" for="use_facebook_bonus"
                      >Aplicar bônus cedido pelo facebook</label
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-check form-check-inline">
                    <input
                      id="use_facebook_prices"
                      class="form-check-input"
                      type="checkbox"
                      v-model="detail.datas.usePricesFacebook"
                      value="0"
                    />
                    <label class="form-check-label" for="use_facebook_prices"
                      >Usar valores do facebook (convertido no valor do dólar
                      atual)</label
                    >
                  </div>
                </div>
              </div>
              <div class="row" v-if="detail.key == 'enterpriseSession'">
                <div class="col-md-6">
                  <div class="form-check form-check-inline">
                    <input
                      id="use_unified_billing"
                      class="form-check-input"
                      type="checkbox"
                      v-model="detail.datas.enterprise_use_unified_billing"
                      value="0"
                      @change="
                        (event) =>
                          onEnterpriseUnifiedCheckboxChange(detail, event)
                      "
                    />
                    <label class="form-check-label" for="use_unified_billing"
                      >Usar cobrança unificada</label
                    >
                  </div>
                </div>
              </div>
              <div
                v-if="
                  detail.datas.enterprise_use_unified_billing == true &&
                  detail.key == 'enterpriseSession'
                "
                style="margin-top: 8px"
              >
                <div class="row">
                  <div class="col-md-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text"> Quantidade </span>
                      </div>
                      <input
                        type="number"
                        class="form-control m-input"
                        v-model="detail.datas.quantity_unified_billing"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text"> Valor </span>
                      </div>
                      <money
                        v-bind="money"
                        class="form-control m-input"
                        v-model="detail.datas.enterprise_session_unified"
                        :readonly="detail.datas.usePricesFacebook"
                      ></money>
                    </div>
                  </div>
                </div>
                <br />
              </div>
              <div v-if="detail.key == 'enterpriseSession'">
                <br />
                <label for="active">Ativos</label>
              </div>
              <hr />
              <div class="row pb-3">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Ativo</span>
                    </div>
                    <input
                      id="active"
                      type="number"
                      step="1"
                      min="0"
                      max="999999999"
                      class="form-control"
                      v-model="detail.datas.quantity_enterprise_session_active"
                      placeholder="0"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Valor excedente</span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.enterprise_session_active"
                    ></money>
                  </div>
                </div>
              </div>

              <div class="row pb-3">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Autenticação</span>
                    </div>
                    <input
                      id="authentication"
                      type="number"
                      step="1"
                      min="0"
                      max="999999999"
                      class="form-control"
                      v-model="
                        detail.datas.quantity_enterprise_session_authentication
                      "
                      placeholder="0"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Valor excedente</span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.enterprise_session_authentication"
                    ></money>
                  </div>
                </div>
              </div>

              <div class="row pb-3">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Utilitário</span>
                    </div>
                    <input
                      id="utility"
                      type="number"
                      step="1"
                      min="0"
                      max="999999999"
                      class="form-control"
                      v-model="detail.datas.quantity_enterprise_session_utility"
                      placeholder="0"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Valor excedente</span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.enterprise_session_utility"
                    ></money>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Marketing</span>
                    </div>
                    <input
                      id="marketing"
                      type="number"
                      step="1"
                      min="0"
                      max="999999999"
                      class="form-control"
                      v-model="
                        detail.datas.quantity_enterprise_session_marketing
                      "
                      placeholder="0"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Valor excedente</span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.enterprise_session_marketing"
                    ></money>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div v-if="detail.key == 'enterpriseSession'">
                <br />
                <label for="receptive">Receptivos</label>
              </div>
              <hr />
              <div class="row pb-3">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Receptivo</span>
                    </div>
                    <input
                      id="receptive"
                      type="number"
                      step="1"
                      min="0"
                      max="999999999"
                      class="form-control"
                      v-model="
                        detail.datas.quantity_enterprise_session_receptive
                      "
                      placeholder="0"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Valor excedente</span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.enterprise_session_receptive"
                    ></money>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Serviço</span>
                    </div>
                    <input
                      id="service"
                      type="number"
                      step="1"
                      min="0"
                      max="999999999"
                      class="form-control"
                      v-model="detail.datas.quantity_enterprise_session_service"
                      placeholder="0"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Valor excedente</span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.enterprise_session_service"
                    ></money>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="row mt-5 mb-3" />
      <div class="row">
        <div class="col-md-12 text-right">
          <p class="p-0 m-0">
            <a
              href="#"
              @click.prevent="$refs.change_reason.$el.focus()"
              target="_self"
              class="m--font-danger"
              v-if="!change_reason"
            >
              O campo
              <strong>Motivo da alteração</strong> é obrigatório *
            </a>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <p class="p-0 m-0">
            <a
              href="#"
              target="_self"
              class="m--font-danger"
              v-if="!validateInfos()"
            >
              Existem cobranças que não foram configuradas valores no campo
              quantidade.
            </a>
          </p>
        </div>
      </div>
      <div class="row mb-5 mt-5">
        <div class="col-md-12" style="text-align: right">
          <button
            @click.prevent="saveForm()"
            class="btn"
            :class="{ 'btn-metal': !formIsValid, 'btn-success': formIsValid }"
            :disabled="!formIsValid"
          >
            <i class="fas fa-save" v-if="formIsValid"></i>
            <i class="fas fa-exclamation-triangle" v-else></i>
            Salvar Plano
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';
import { tooltipMixin } from '@/mixins/tooltipMixin.js';

import { Money } from 'v-money';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin, tooltipMixin],
  props: {
    changeReason: String,
  },
  name: 'PlanServices',
  components: { Money },
  data() {
    return {
      data: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      change_reason: null,
    };
  },
  methods: {
    checkSucessEnterpriseSession(detail) {
      return (
        detail.key == 'enterpriseSession' &&
        (detail.datas.enterprise_session_active > 0 ||
          detail.datas.quantity_enterprise_session_active > 0 ||
          detail.datas.enterprise_session_receptive > 0 ||
          detail.datas.quantity_enterprise_session_receptive > 0 ||
          detail.datas.enterprise_session_authentication > 0 ||
          detail.datas.quantity_enterprise_session_authentication > 0 ||
          detail.datas.enterprise_session_utility > 0 ||
          detail.datas.quantity_enterprise_session_utility > 0 ||
          detail.datas.enterprise_session_marketing > 0 ||
          detail.datas.quantity_enterprise_session_marketing > 0 ||
          detail.datas.enterprise_session_service > 0 ||
          detail.datas.quantity_enterprise_session_service > 0)
      );
    },
    onEnterpriseUnifiedCheckboxChange(detail, event) {
      if (!event.target.checked) {
        detail.datas.quantity_unified_billing = '';
        detail.datas.enterprise_session_unified = '';
      }
    },
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      const url = `${baseApiUrl}/v1/plans/service/save`;
      axios
        .post(url, {
          planId: this.planId,
          changeReason: this.change_reason,
          services: this.data,
        })
        .then((res) => {
          this.logMessageForm(res);
          this.$emit('changedReason', this.change_reason);
          this.callData();
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/plans/service/data/${this.planId}`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
    callData() {
      this.getDatas();
    },
    validateInfos() {
      let count = 0;
      Object.keys(this.data).forEach((detail) => {
        if (detail.datas) {
          if (detail.datas.surplus_price > 0 && detail.datas.amount < 1) {
            count++;
          }
        }
      });
      if (count > 0) {
        return false;
      }
      return true;
    },
  },
  computed: {
    planId() {
      return this.$store.state.showPlanSave;
    },
    formIsValid() {
      if (this.change_reason && this.validateInfos()) {
        return true;
      }
      return false;
    },
  },
  watch: {
    planId() {
      if (this.planId !== 'add') {
        this.callData();
      }
    },
    changeReason() {
      this.change_reason = this.changeReason;
    },
  },
  beforeMount() {
    if (this.planId !== 'add') {
      this.callData();
    }
  },
};
</script>
